import React, { useState, useEffect } from 'react';
import { RemoveRedEye, ArrowDropDown, Clear } from '@mui/icons-material';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
} from '@mui/material';
import { toaster } from 'evergreen-ui';
import Quotations from '../api/quotations';
import Users from '../api/users';
import MultiSelectFilter from '../components/ui/MultiSelectFilter';
import Divider from '../components/ui/Divider';
import Modal from '../components/ui/Modal';
import { toInteger } from '../utilities';
/* eslint max-len: ["error", { "code": 250 }] */

const ClientQuotations = () => {
  const [showAddAdditionalInfo, setShowAddAdditionalInfo] = useState({
    showModal: false,
    id: true,
    materials: false,
    quotation_name: true,
    machine: true,
    cost_per_piece: false,
    cost_electricity: false,
    cost_operator: false,
    cost_total_per_piece: true,
    price_per_design: true,
    utility: true,
    pieces_to_sell: false,
    show_pdf: false,
  });
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [showOrderOptions, setShowOrderOptions] = useState(false);
  const [isLoading, setIsLoading] = useState({ clients: false, quotations: false });
  const [allQuotations, setAllQuotations] = useState([]);
  const [mockQuotations, setMockQuotations] = useState([]);
  const [allClients, setAllClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const userId = localStorage.getItem('id');

  const handleFilterByQuotationName = (value) => {
    const filteredQuotations = allQuotations.map((item, index) => {
      const clientQuotations = mockQuotations[index].quotations.filter((quotation) => quotation.quotation_name.toLowerCase().includes(value.toLowerCase()));
      return {
        ...item,
        quotations: clientQuotations,
      };
    });
    setAllQuotations(filteredQuotations);
  };

  useEffect(async () => {
    setIsLoading({ clients: true, quotations: false });
    const userData = await Users.getUser(userId);
    setAllClients(userData.clients);
    setIsLoading({ clients: false, quotations: false });
  }, []);

  useEffect(() => {
    if (allClients?.length === 0) return;
    setIsLoading({ clients: false, quotations: true });
    if (selectedClients?.length > 0) {
      Promise.all(selectedClients.map((client) => Quotations.existingClient.get(userId, client.id)))
        .then((response) => {
          setAllQuotations(response.map((item) => (item.length > 0 ? item[0] : item)));
          setMockQuotations(response.map((item) => (item.length > 0 ? item[0] : item)));
          setIsLoading({ clients: false, quotations: false });
        })
        .catch((err) => console.log(err));
    } else {
      setAllQuotations([]);
      setIsLoading({ clients: false, quotations: false });
    }
  }, [selectedClients]);

  return (
    <>
      <div style={{ margin: '50px' }} className="container">
        <p className="header">TUS COTIZACIONES DE CLIENTES</p>
        <div>
          <div className="banner-container">
            <MultiSelectFilter
              array={allClients}
              placeholderInput="Seleccionar clientes"
              placeholderFilter="Buscar clientes"
              listTitle="Clientes:"
              propertyShown="client"
              propertyId="id"
              selectedValues={selectedClients}
              setSelectedValues={setSelectedClients}
              loading={isLoading.clients || isLoading.quotations}
            />
            <div className="clients-bar-wrapper">
              {selectedClients?.length > 0 && selectedClients.map((client) => (
                <div
                  role="none"
                  className="client-item"
                  onClick={() => {
                    if (isLoading.quotations) {
                      toaster.warning('Cargando, espere un momento', {
                        id: 'forbidden-action',
                        duration: 1.5,
                      });
                    } else {
                      setSelectedClients((prevState) => prevState.filter((arrayItem) => (
                        arrayItem.id !== client.id
                      )));
                    }
                  }}
                >
                  <p>{client.client}</p>
                  <p className="clear-symbol">x</p>
                </div>
              ))}
            </div>
          </div>

          <div className="filters-container">
            <input placeholder="Filtrar por nombre de cotizacion" onChange={(e) => handleFilterByQuotationName(e.target.value)} />
            <button disabled type="button" className="simple-button" onClick={() => setShowFilterOptions(!showFilterOptions)}>Filtrar</button>
            <button
              type="button"
              className="simple-button"
              onClick={() => setShowAddAdditionalInfo((prevSate) => ({ ...prevSate, showModal: !prevSate.showModal }))}
            >
              <RemoveRedEye />
              Mostrar
            </button>
            <button disabled type="button" className="simple-button" onClick={() => setShowOrderOptions(!showOrderOptions)}>Ordenar</button>
          </div>
        </div>

        <div style={{ marginTop: '30px' }}>
          {isLoading.quotations && (<div style={{ textAlign: 'center' }}><CircularProgress color="inherit" /></div>)}
          {(allQuotations?.length > 0 && !isLoading.quotations) && allQuotations.map((client, index) => (
            <Accordion
              className="accordion"
              // defaultExpanded
              sx={{ boxShadow: 'none', margin: '10px 0 30px 0 !important', backgroundColor: 'transparent' }}
            >
              <AccordionSummary
                className="accordion-summary-sidebar"
                expandIcon={<ArrowDropDown />}
                aria-controls="panel1a-content"
                id="panel0a-header-asidebar"
                style={{
                  margin: '0', minHeight: '0', display: 'flex', alignItems: 'center',
                }}
              >
                {`${index + 1} ._  Cliente: ${client.client} / Empresa: ${client.company_name}`}
                {client.company_logo
                && (
                  <img
                    style={{
                      width: '50px', maxWidth: '200px', objectFit: 'contain', marginLeft: '10px',
                    }}
                    alt={`img_${client?.id}`}
                    src={client.company_logo}
                  />
                )}
              </AccordionSummary>
              <AccordionDetails>
                <div className="client-quotations-container">
                  {client.quotations?.length > 0 ? client.quotations.map((quotation) => (
                    <div key={quotation.id} className="client-quotations-wrapper">
                      <Divider label="Datos de la Cotizacion" />
                      {showAddAdditionalInfo.id && (
                      <div>
                        <p>Id :</p>
                        <p>{quotation.id}</p>
                      </div>
                      )}
                      {showAddAdditionalInfo.quotation_name && (
                      <div>
                        <p>Cotizacion :</p>
                        <p>{quotation.quotation_name}</p>
                      </div>
                      )}
                      {showAddAdditionalInfo.machine && (
                      <div>
                        <p>Maquina :</p>
                        <p>{quotation.machine}</p>
                      </div>
                      )}
                      {(showAddAdditionalInfo.materials && quotation.type_material?.length > 0) && (
                      <div>
                        <p>Materiales :</p>
                        <p>{quotation.type_material.join()}</p>
                      </div>
                      )}
                      <Divider label="Detalle de costos" />
                      {showAddAdditionalInfo.cost_per_piece && (
                      <div>
                        <p>Costo por diseño :</p>
                        <p>{quotation.cost_per_piece}</p>
                      </div>
                      )}
                      {showAddAdditionalInfo.cost_electricity && (
                      <div>
                        <p>Costo de electricidad :</p>
                        <p>{quotation.cost_electricity}</p>
                      </div>
                      )}
                      {showAddAdditionalInfo.cost_operator && (
                      <div>
                        <p>Costo de operacion :</p>
                        <p>{quotation.cost_operator}</p>
                      </div>
                      )}
                      {showAddAdditionalInfo.cost_total_per_piece && (
                      <div>
                        <p>Costo total del diseño :</p>
                        <p>{quotation.cost_total_per_piece}</p>
                      </div>
                      )}
                      {showAddAdditionalInfo.price_per_design && (
                      <div>
                        <p>Precio de venta :</p>
                        <p>{quotation.price_per_design}</p>
                      </div>
                      )}
                      <Divider textColor="green" label="Retorno de inversion" />
                      {showAddAdditionalInfo.utility && (
                      <div>
                        <p>Utilidad :</p>
                        <p>{toInteger(quotation.price_per_design - quotation.cost_total_per_piece, 2)}</p>
                      </div>
                      )}
                      {showAddAdditionalInfo.pieces_to_sell && (
                      <div>
                        <p>Piezas a vender:</p>
                        <p>{quotation.pieces_to_sell}</p>
                      </div>
                      )}
                      {showAddAdditionalInfo.show_pdf && (
                      <iframe title={quotation.id} src={quotation.pdf_url} scrolling="no" height="400px" width="100%" />
                      )}
                      <a style={{ textDecoration: 'none' }} href={quotation.pdf_url} download rel="noreferrer" target="_blank">
                        <button style={{ margin: '20px auto 0 auto' }} className="simple-button" type="button">Abrir</button>
                      </a>
                    </div>
                  ))
                    : <p style={{ margin: '30px auto', textAlign: 'center' }}>Sin Cotizaciones</p>}
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>

      {showAddAdditionalInfo.showModal
      && (
      <Modal className="modal-see-additional-info">
        <button
          type="button"
          className="simple-button"
          style={{
            position: 'absolute', top: '10px', right: '10px', borderRadius: '5px',
          }}
          onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, showModal: false }))}
        >
          <Clear style={{ fontSize: '15px' }} />
        </button>
        <p>Ver Informacion Adicional:</p>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, id: !showAddAdditionalInfo.id }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.id}
          />
          <p>Id</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, quotation_name: !showAddAdditionalInfo.quotation_name }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.quotation_name}
          />
          <p>Nombre de la cotizacion</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, machine: !showAddAdditionalInfo.machine }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.machine}
          />
          <p>Maquina</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, materials: !showAddAdditionalInfo.materials }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.materials}
          />
          <p>Materiales</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, cost_per_piece: !showAddAdditionalInfo.cost_per_piece }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.cost_per_piece}
          />
          <p>Costo por diseño</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, cost_electricity: !showAddAdditionalInfo.cost_electricity }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.cost_electricity}
          />
          <p>Costo de electricidad</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, cost_operator: !showAddAdditionalInfo.cost_operator }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.cost_operator}
          />
          <p>Costo de operacion</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, cost_total_per_piece: !showAddAdditionalInfo.cost_total_per_piece }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.cost_total_per_piece}
          />
          <p>Costo total del diseño</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, price_per_design: !showAddAdditionalInfo.price_per_design }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.price_per_design}
          />
          <p>Precio de venta</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, utility: !showAddAdditionalInfo.utility }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.utility}
          />
          <p>Utilidad</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, pieces_to_sell: !showAddAdditionalInfo.pieces_to_sell }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.pieces_to_sell}
          />
          <p>Piezas a vender</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, show_pdf: !showAddAdditionalInfo.show_pdf }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.show_pdf}
          />
          <p>previsualizar PDF</p>
        </div>
      </Modal>
      )}
      {showFilterOptions
      && (
      <Modal className="modal-see-additional-info">
        <p>Ver Informacion</p>
        <div>
          <input type="checkbox" />
          <p>Id</p>
        </div>
        <div>
          <input type="checkbox" />
          <p>Costo de operacion</p>
        </div>
        <div>
          <input type="checkbox" />
          <p>Costo de electricidad</p>
        </div>
        <div>
          <input type="checkbox" />
          <p>Piezas a vender</p>
        </div>
        <div>
          <input type="checkbox" />
          <p>previsualizar PDF</p>
        </div>
      </Modal>
      )}
      {showOrderOptions
      && (
      <Modal className="modal-see-additional-info">
        <p>Ver Informacion</p>
        <div>
          <input type="checkbox" />
          <p>Id</p>
        </div>
        <div>
          <input type="checkbox" />
          <p>previsualizar PDF</p>
        </div>
      </Modal>
      )}
    </>
  );
};

export default ClientQuotations;
